<template>
    <b-form
        ref="editForm"
        :save-url="addUrl"
        @success="formSuccess"
        @failure="formFailure"
        v-slot="{model, loading}"
        :initial-data="initialData"
        :save-params="{api_key: currentUser.api_key}"
    >
        <div class="row">
            <div class="col-12">
                <validated-input
                    label="Title"
                    v-model="model.title"
                    :rules="{ required: true }"
                    :disabled="loading"
                />
            </div>

            <div class="col-12">
                <filee-input
                    ref="posterInput"
                    class="c-file-input"
                    label="Poster Front Side"
                    v-model="model.poster"
                    :disabled="loading"
                    @input="validatePoster($event, model)"
                />
            </div>

            <div class="col-12">
                <file-input
                    ref="poster2Input"
                    class="c-file-input"
                    label="Poster Back Side"
                    v-model="model.poster_2"
                    :disabled="loading"
                    @input="validatePoster2($event, model)"
                />
            </div>

            <div class="col-12">
                <image-info :width="447" :height="596"/>
            </div>

            <div class="col-6">
                <checkbox-input
                    label="Disabled"
                    v-model="model.disabled"
                    :rules="{ required: false }"
                    :disabled="loading"
                />
            </div>

            <div class="col-12 text-right">
                <btn
                    class="trn"
                    text="Update"
                    loading-text="Updating..."
                    size="sm"
                    :disabled="loading"
                    :loading="loading"
                />
            </div>
        </div>
    </b-form>
</template>

<script>
import urls from '../../../../data/urls';
import { mapGetters } from 'vuex';

export default {
    name : 'EditFlyer',

    computed : {
        ...mapGetters(['currentUser'])
    },

    props : {
        initialData : {
            type : Object
        }
    },

    data () {
        return {
            addUrl : urls.admin.event.flyer.addEdit
        };
    },

    methods : {
        validatePoster (files, model) {
            if (!files || files.length === 0) {
                return;
            }

            const file = files[0];

            // Skip validation if existing image string
            if (!(file instanceof File)) {
                return;
            }

            const image = new Image();

            image.onload = () => {
                URL.revokeObjectURL(image.src);

                if (image.width !== 447 || image.height !== 596) {
                    this.$notify(
                        'Please upload an image with dimensions 447 × 596 pixels.',
                        'Invalid Image',
                        {
                            type : 'warning'
                        }
                    );

                    this.$refs.posterInput.text = '';
                    this.$refs.posterInput.files = [];
                    model.poster = [];

                    return;
                }

                model.poster = files;
            };

            image.src = URL.createObjectURL(file);
        },

        validatePoster2 (files, model) {
            if (!files || files.length === 0) {
                return;
            }

            const file = files[0];

            // Skip validation if existing image string
            if (!(file instanceof File)) {
                return;
            }

            const image = new Image();

            image.onload = () => {
                URL.revokeObjectURL(image.src);

                if (image.width !== 447 || image.height !== 596) {
                    this.$notify(
                        'Please upload an image with dimensions 447 × 596 pixels.',
                        'Invalid Image',
                        {
                            type : 'warning'
                        }
                    );

                    this.$refs.poster2Input.text = '';
                    this.$refs.poster2Input.files = [];
                    model.poster_2 = [];

                    return;
                }

                model.poster_2 = files;
            };

            image.src = URL.createObjectURL(file);
        },

        formSuccess () {
            this.$notify(
                'Successfully Updated Flyer..!',
                'Success',
                {
                    type : 'success'
                }
            );

            this.$emit('success');
        },

        formFailure (response) {
            if (!response) {
                this.$notify(
                    'Something went wrong..!',
                    'Error',
                    {
                        type : 'danger'
                    }
                );
                return;
            }

            const errors = response.data.errors;

            for (const key in errors) {
                if (Object.prototype.hasOwnProperty.call(errors, key)) {
                    let errorMessage = '';

                    if (key === '__all__') {
                        errorMessage = `${errors[key]}`;
                    } else {
                        errorMessage = `${key}: ${errors[key]}`;
                    }

                    this.$notify(
                        errorMessage,
                        'Warning',
                        {
                            type : 'warning'
                        }
                    );
                }
            }
        }
    }
};
</script>

<style scoped>

</style>
